import { useNavigate } from 'react-router-dom';

import {
  openErrorNotification,
  openSuccessNotification,
  isErrorWithMessage,
} from 'shared/lib';
import { CPO_ROUTES } from 'shared/consts/routes/cpo';

import {
  CpoFormData,
  ConnectedCpoForm,
  useAddCpoMutation,
  prepareRequestData,
} from 'entities/cpo';

import { ADD_SUCCESS, ADD_ERROR } from '../consts';

const initialValues: CpoFormData = {
  id: '',
  name: '',
  ocpiHubId: '',
  ownerId: '',
  partyId: '',
  legalEntity: '',
  contacts: '',
  description: '',
  inn: '',
  mapShow: false,
  diplink: '',
  icon: '',
  tariff: '',
  phone: '',
  telegramm: '',
};

export function AddCpo() {
  const [trigger, { isLoading }] = useAddCpoMutation();

  const navigate = useNavigate();

  const handleSubmit = async (values: CpoFormData) => {
    const { id, ...req } = prepareRequestData(values);

    try {
      const res = await trigger(req).unwrap();

      // костыль
      if (res.statusCode !== 0) {
        openErrorNotification(res.statusDescription);

        return;
      }
      //

      openSuccessNotification(ADD_SUCCESS);

      navigate(`${CPO_ROUTES.CPOS}/${res.cpo.id}`);
    } catch (err) {
      const hasErrorMessage = isErrorWithMessage(err);

      const errorText = hasErrorMessage
        ? err.data.statusDescription
        : ADD_ERROR;

      openErrorNotification(errorText);
    }
  };

  return (
    <ConnectedCpoForm
      title="Добавление нового оператора ЭЗС"
      handleSubmit={handleSubmit}
      initialValues={initialValues}
      loading={isLoading}
    />
  );
}
